import { IconButton } from 'components/IconButton/IconButton'
import { ArrowLeft } from 'almanac-ui/icons'
import { useStepper } from 'components/AIRevision/Stepper/StepperProvder'

export const BackButton = () => {
  const { stepBackward, step } = useStepper()
  const onFirstStep = step <= 1

  return (
    <IconButton
      isDisabled={onFirstStep}
      icon={ArrowLeft}
      size="sm"
      variant="tertiary"
      aria-label="Previous"
      onPress={stepBackward}
    />
  )
}
